export const timedCache = (time, cacheStore, setRefreshData) => {
    const tokenTime = localStorage.getItem('d_expires');
    const dateNow = Date.now();
    const tokenExpire = time;
    const getHours = (milliseconds) => {
      let seconds = Math.floor(milliseconds / 1000);
      let minutes = Math.floor(seconds / 60);
      let hours = Math.floor(minutes / 60);
      return Math.floor(hours);
    }
    const compareTime = getHours(dateNow - tokenTime);

    if(compareTime >= tokenExpire){
      cacheStore.forEach(element => {
        localStorage.removeItem(element);
      });
      setRefreshData(true);
    } 
}

export const normalizeVariant = (variant) => {
    // Normalize the variant name where it may be entered in different formats (e.g. "100ml", "100 ml", "100ML") to ensure consistency in how we access variant data downstream.
    // this function take in a variant string which is entered as plain text and evaluates whether it contains a variant indication in various text formats
    const forwardVariant = variant?.toString().toLowerCase().replace(/\s/g, "").indexOf("100ml") > -1;
    return forwardVariant;
}